import PropTypes from 'prop-types'
import '../../styles/components/pill/base-pill.scss'

const StatusPill = ({ title, color }) => {
  return (
    <div className={`base-pill ${title.replace(/\s+/g, '')}`} style={{ backgroundColor: color }}>
      {title}
    </div>
  )
}

StatusPill.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
}

export default StatusPill
